<template>
    <div class="orderdetails_content">
        <div class="orderdetails_head_content">
            <table>
                <colgroup>
                    <col width="11.5873%">
                    <col width="21.746%">
                    <col width="11.5873%">
                    <col width="21.746%">
                    <col width="11.5873%">
                    <col width="21.746%">
                </colgroup>
                <tbody>
                    <tr>
                        <th><span>订单号：</span></th>
                        <td><span>{{orderinfo.orderdno}}</span><small style="color: red;" v-if="orderinfo.batchcost >= 0"> (特批价)</small></td>
                        <th><span>订单状态：</span></th>
                        <td><span :style="{color: orderinfo.status != 4 && orderinfo.status != 5 && orderinfo.status != 6 ? '#FF8000' : ''}">{{orderinfo.statusname}}</span></td>
                        <th><span>订单金额：</span></th>
                        <td><span>￥{{orderinfo.allcost}}</span><small style="color: #999;" v-if="orderinfo.ordertype == 1"> {{orderinfo.ordertypename}}</small></td>
                    </tr>
                    <tr>
                        <th><span>订单时间：</span></th>
                        <td><span>{{orderinfo.addtime}}</span></td>
                        <th><span>付款状态：</span></th>
                        <td><span :style="{color: orderinfo.fundstatus != 4 && orderinfo.fundstatus != 5 ? '#FF8000' : ''}">{{orderinfo.fundstatusname}}</span></td>
                        <th><span>待付金额：</span></th>
                        <td>
                            <span>￥{{orderinfo.waitcost}}</span>
                            <small style="color: #999;" v-if="autocancle > 0 && orderinfo.fundstatus == 0"> 支付剩余时间：<small style="color: #FF8000;">{{autocancletime}}</small></small>
                        </td>
                    </tr>
                    <tr>
                        <th v-if="orderinfo.closereason != ''"><span>取消原因：</span></th>
                        <td v-if="orderinfo.closereason != ''"><span>{{orderinfo.closereason}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="tabs_content">
            <ul>
                <li class="active">订货详情</li>
                <li @click="orderjump(2)">出库/发货/物流</li>
                <li @click="orderjump(3)">付款记录</li>
            </ul>
        </div>
        <div class="orderdetails_box">
            <div class="shoppingcart_head_check_content">
                <div class="shoppingcart_head_check_left">
                    <RadioGroup v-model="sort" size="large">
                        <Radio :label=1>按下单排序</Radio>
                        <Radio :label=2>按商品编号排序</Radio>
                    </RadioGroup>
                </div>
                <div class="shoppingcart_head_check_right">
                    <div class="export_excel_btn" @click="orderdownclick"><i class="icon iconfont icon-excel"></i>导出Excel</div>
                    <Button type="error" @click="againbuyBtn">再次购买</Button>
                    <Button @click="cancelorderBtn" v-if="orderinfo.status == 0 && orderinfo.status != 5">取消订单</Button>
                    <Button type="warning" @click="returnorderBtn" v-if="orderinfo.status == 4 && orderinfo.returngoods == 0 || orderinfo.status == 4 && orderinfo.returngoods == 1 && orderinfo.returngoodstime > 0">申请退货</Button>
                    <Button type="warning" v-if="orderinfo.waitcost > 0 && orderinfo.fundstatus < 5 && orderinfo.status != 5 && orderinfo.reback != 2 || orderinfo.waitcost > 0 && orderinfo.fundstatus < 5 && orderinfo.status != 5 && orderinfo.reback != 3" @click="payBtn">付款</Button>
                </div>
            </div>
            <div class="orderdetails_table_content pad0">
                <Table
                    border
                    ref="selection"
                    :columns="thead"
                    :data="goodslist"></Table>
            </div>
            <div class="orderdetails_orderprice">
                <ul>
                    <li><span>商品金额：</span><small>{{parseFloat(orderinfo.goodscost).toFixed(2)}}</small></li>
                    <li><span>税费：</span><small>+{{parseFloat(orderinfo.tax_cost).toFixed(2)}}</small></li>
                    <li><span>运费：</span><small>+{{parseFloat(orderinfo.shopps).toFixed(2)}}</small></li>
                    <li><span>优惠金额：</span><small>-{{parseFloat(orderinfo.cxcost).toFixed(2)}}</small></li>
                    <li><span>优惠券金额：</span><small>-{{parseFloat(orderinfo.yhjcost).toFixed(2)}}</small></li>
                </ul>
                <span>订单金额：</span><small>{{orderinfo.allcost}}元</small><small style="color: #666;" v-if="orderinfo.batchcost >= 0"> (特批价)</small>
            </div>
        </div>
        <div class="h6"></div>
        <div class="orderdetails_info_content">
            <div class="goods_details_bottom_content">
                <Tabs>
                    <TabPane label="订单信息">
                        <div class="orderdetails_info_list">
                            <ul>
                                <li>
                                    <div class="orderdetails_info_left"><span class="letter">备注：</span></div>
                                    <div class="orderdetails_info_right"><span>{{orderinfo.content}}</span></div>
                                </li>
                                <li v-if="orderinfo.billtype != 0">
                                    <div class="orderdetails_info_left"><span>发票信息：</span></div>
                                    <div class="orderdetails_info_right">
                                        <span>{{orderinfo.billtype == 1 ? '普通发票' : '增值税发票'}}（{{orderinfo.tax_rat}}%税点）</span>
                                        <small>发票抬头：{{orderinfo.billtitle}}</small>
                                        <small>纳税人识别号：{{orderinfo.billnumber}}</small>
                                        <small>发票内容：{{orderinfo.billcontent}}</small>
                                        <template v-if="orderinfo.billtype == 2">
                                            <small>注册人地址：{{orderinfo.regaddress}}</small>
                                            <small>注册电话：{{orderinfo.regphone}}</small>
                                            <small>开户名称：{{orderinfo.bankuser}}</small>
                                            <small>开户银行：{{orderinfo.bankname}}</small>
                                            <small>银行账号：{{orderinfo.banknumber}}</small>
                                        </template>
                                    </div>
                                </li>
                                <li>
                                    <div class="orderdetails_info_left"><span>交货日期：</span></div>
                                    <div class="orderdetails_info_right"><span>{{orderinfo.delivertime}}</span></div>
                                </li>
                                <li>
                                    <div class="orderdetails_info_left"><span>收货地址：</span></div>
                                    <div class="orderdetails_info_right"><span>{{orderinfo.address}}</span></div>
                                </li>
                                <li>
                                    <div class="orderdetails_info_left"><span class="letter">附件：</span></div>
                                    <div class="orderdetails_info_right">
                                        <div class="uploadfile_content">
                                            <small v-if="orderinfo.status == 0">（请上传图片，最多5张，单张大小不超过6M，支持格式：PDF,WORD,EXCEL,TXT,JPG,JPEG,PNG,GIF,RAR,ZIP）</small>
                                            <small v-else>当前状态不能上传附件</small>
                                            <Upload
                                                ref="upload"
                                                :disabled="orderinfo.status != 0"
                                                :action="action"
                                                :show-upload-list="false"
                                                :default-file-list="defaultList"
                                                :multiple="true"
                                                :format="['pdf','word', 'doc', 'excel','txt','jpg','jpeg','png','gif','rar','zip']"
                                                accept=".pdf, .word, .doc, .excel, .txt, .jpg, .jpeg, .png, .gif, .rar, .zip"
                                                name="imgFile"
                                                :max-size="filemaxsize"
                                                :before-upload="uploadBefore"
                                                :on-progress="uploadProgress"
                                                :on-success="uploadSuccess"
                                                :on-error="uploadError"
                                                :on-remove="uploadRemove"
                                                :on-exceeded-size="uploadExceededSize"
                                            >
                                                <Button class="uploadfile_btn">选择文件</Button>
                                            </Upload>
                                            <div class="uploadfile_list">
                                                <ul>
                                                    <li v-for="(item, index) in uploadList" :key="index">
                                                        <template v-if="item.status === 'finished'">
                                                            <span>{{item.name}}</span>
                                                            <a :href="item.url" target="_blank">查看</a>
                                                            <a href="javascript:;" @click="deluploadfile(item.url)">删除</a>
                                                        </template>
                                                        <template v-else>
                                                            <div style="width: 260px;">
                                                                <Progress v-if="item.showProgress" :percent="item.percentage"></Progress>
                                                            </div>
                                                        </template>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        </div>
        <!-- 删除选中商品弹窗 -->
        <Modal
            class="agreement_content"
            v-model="orderpopup"
            :width="346"
            :scrollable="false"
            cancel-text="取消"
            ok-text="确定"
            @on-ok="orderpopupOk">
            <div slot="header" class="model_head">
                <span>提示</span>
            </div>
            <div class="model_body">{{orderpopupmsg}}</div>
        </Modal>
        <!-- 取消订单原因 -->
        <Cancelorder :cancelorderShow="cancelorderShow" :cancelorderInfo="cancelorderInfo" @cancelorderOk="cancelorderOk" @cancelorderCancel="cancelorderCancel"></Cancelorder>
    </div>
</template>

<script>
import api from '@/request/api.js'
import Cancelorder from '@/components/component/popup/cancelorder.vue'
import {toMoney} from '@/filter/moneyFilter.js'
export default {
    components: {Cancelorder},
    data () {
        return {
            orderpopup: false, // 提示弹窗
            orderpopupmsg: '', // 提示弹窗文字
            cancelorderShow: false, // 取消订单弹窗是否显示
            cancelorderInfo: '', // 取消订单原因
            orderpopupsign: 0, // 0 再次购买 1 取消订单 2 申请退货 3 删除已上传附件
            thead: [ // 表格头部
                {
                    type: 'index',
                    width: 50,
                    align: 'center',
                },
                {
                    width: 320,
                    align: 'center',
                    title: '商品',
                    key: 'goods',
                    render: (h, params) => {
                        return h('div', // 商品
                                    [
                                        h('div', // 商品图片
                                            {
                                                class: 'shoppingcart_goods_left',
                                                style: {
                                                    backgroundImage: 'url(' + params.row.goodsimg + ')'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.goto(params.row.goodsid)
                                                    }
                                                },
                                            }
                                        ),
                                        h('div', // 商品右侧信息
                                            {
                                                class: 'shoppingcart_goods_right'
                                            },
                                            [   
                                                h('Poptip',
                                                    {
                                                        props: {
                                                            trigger: 'hover',
                                                            width: '246',
                                                            wordWrap: true,
                                                            content: params.row.goodsname
                                                        }
                                                    },
                                                    [
                                                        h('span', // 商品名称
                                                            {
                                                                class: 'shoppingcart_goods_name'
                                                            },
                                                            [
                                                                h('b',
                                                                    {
                                                                        style: {
                                                                            backgroundColor: params.row.cxtype == 1 ? '#FF8000' : '#40a250',
                                                                            display: params.row.cxtype == 1 || params.row.cxtype == 2 ? 'inline' : 'none'
                                                                        }
                                                                    },
                                                                    params.row.cxtype == 1 ? '特价' : (params.row.cxtype == 2 ? '折扣' : '')
                                                                ),
                                                                h('b', {style: {
                                                                            backgroundColor: params.row.is_send == 1 ? '#FF8000' : '',
                                                                            display: params.row.is_send == 1 ? 'inline' : 'none'
                                                                        }
                                                                    },
                                                                    params.row.is_send == 1 ? '赠品' : ''
                                                                ),
                                                                h('span', params.row.goodsname)
                                                            ]
                                                        ),
                                                    ]
                                                ),
                                                h('small', // 商品编号
                                                    '商品编号：' + params.row.commcode
                                                )
                                            ]
                                        ),
                                    ]
                                )
                    }
                },
                {
                    align: 'center',
                    title: '规格',
                    key: 'gg_attrname'
                },
                {
                    align: 'center',
                    title: '单位',
                    key: 'unit',
                    render: (h, params) => {
                        if (!params.row.unitshow) {
                            return h('span', params.row.unit)
                        } 
                        if (params.row.unitshow) {
                            return h('div', {class: 'orderdetailunit'},
                                        [
                                            h('span', params.row.unit),
                                            h('small', '1' + params.row.maxunit + '=' + params.row.matrixing + params.row.unit),
                                        ]
                                    )
                        }
                    }
                },
                {
                    align: 'center',
                    title: '订购数量',
                    key: 'pcordernum',
                    render: (h, params) => {
                        return h('span', params.row.pcordernum + (params.row.unitshow ? params.row.maxunit : params.row.unit))
                    }
                },
                {
                    align: 'center',
                    title: '已发货数',
                    key: 'sendcount'
                },
                {
                    align: 'center',
                    title: '待发货数',
                    key: 'staynum',
                    render: (h, params) => {
                        return h('span',
                                    parseInt(params.row.ordernum) - parseInt(params.row.sendcount)
                                )
                    }
                },
                {
                    align: 'center',
                    title: '单价',
                    key: 'goodscost',
                    render: (h, params) => {
                        if (params.row.is_send == 1) return h('del', params.row.goodscost)
                        if (params.row.is_send == 0) return h('span', params.row.goodscost)
                    }
                },
                {
                    align: 'center',
                    title: '小计',
                    key: 'oldcost',
                    render: (h, params) => {
                        if (params.row.is_send == 1) return h('span', '0.00')
                        if (params.row.is_send == 0) {
                            return h('span',
                                        (params.row.ordernum * params.row.goodscost).toFixed(2)
                                    )
                        }
                    }
                },
                {
                    width: 166,
                    align: 'center',
                    title: '备注',
                    key: 'ordergoodscontent',
                    render: (h, params) => {
                        if (params.row.ordergoodscontent != '') {
                            return h('Poptip',
                                        {
                                            props: {
                                                trigger: 'hover',
                                                content: params.row.instro,
                                                width: '170',
                                                wordWrap: true
                                            }
                                        },
                                        [
                                            h('span',
                                                {
                                                    class: 'shoppingcart_goods_remarks',
                                                    style: {fontSize: '14px'}
                                                },
                                                params.row.ordergoodscontent
                                            )
                                        ],
                                    )
                        }
                    }
                }
            ],
            goodslist: [], // 表格列表
            orderinfo: {}, // 订单详情信息
            autocancle: 0, // 剩余支付时间
            autocancletime: 0, // 剩余支付时间
            livetime: 0, // 订单未支付或待收货状态下的倒计时时间
            sort: 1, // 排序方式 1 按下单排序 2 按商品编号排序
            action: this.getWebsite() + api.upload + this.getCookie('cook_ShopId') + '&cus_uid=' + this.getCookie('cook_cus_uid') + '&cus_pwd=' + this.getCookie('cook_cus_pwd') + '&orderid=' + this.$route.params.id, // 上传文件地址
            filemaxsize: Math.pow(4, 6), // 文件大小限制
            defaultList: [], // 默认上传文件列表
            uploadList: [], // 显示已上传列表
        }
    },
    methods: {
        getInfo () { // 获取订单详情
            this.http.post(api.orderdetail, {id: this.$route.params.id, sorttype: this.sort})
            .then(response => {
                console.log(response.data.msg)
                if (!response.data.error) {
                    this.orderinfo = response.data.msg.order
                    this.livetime = response.data.msg.order.livetime
                    this.autocancle = response.data.msg.order.autocancle
                    if (response.data.msg.order.autocancle > 0) this.TimeDown(response.data.msg.order.autocancletime)
                    this.goodslist = response.data.msg.order.det
                    if (response.data.msg.order.orderaccessory != null) {
                        for (var i = 0; i < response.data.msg.order.orderaccessory.length; i++) {
                            response.data.msg.order.orderaccessory[i].percentage = 100
                            response.data.msg.order.orderaccessory[i].status = "finished"
                        }
                        this.uploadList = response.data.msg.order.orderaccessory
                    }
                } else {
                    this.$Message.warning(response.data.msg)
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        delupload (urls) { // 删除上传文件
            this.http.post(api.delupload,
                {
                    orderid: this.orderinfo.id,
                    file: urls
                }
            )
            .then(response => {
                console.log(response.data.msg)
                if (!response.data.error) {
                    this.$Message.success(response.data.msg)
                    this.getInfo()
                } else {
                    this.$Message.warning(response.data.msg)
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        ordercanceljudge () { // 判断是否可以正常取消订单
            this.http.post(api.ordercanceljudge, {id: this.$route.params.id})
            .then(response => {
                console.log(response.data)
                if (!response.data.error) {
                    this.cancelorderShow = true
                } else {
                    this.$Message.warning(response.data.msg)
                }
            })
            .catch(error => {
                this.$Message.error(error);
            })
        },
        ordercancel () { // 取消订单
            this.http.post(api.ordercancel,
                {
                    id: this.$route.params.id,
                    ifzidong: 0,
                    closereason: this.cancelorderInfo
                }
            )
            .then(response => {
                console.log(response.data.msg)
                if (!response.data.error) {
                    this.$Message.success(response.data.msg)
                    this.getInfo()
                } else {
                    this.$Message.warning(response.data.msg)
                }
            })
            .catch(error => {
                this.$Message.error(error)
            })
        },
        goto (id) { // 跳转商品详情页
            this.$router.push({
                name: '商品详情',
                params: {
                    id: id
                }
            })
        },
        orderdownclick () { // 导出表格
            window.open(this.getWebsite() + api.orderdown + '&shopid=' + this.getCookie('cook_ShopId') + '&cus_uid=' + this.getCookie('cook_cus_uid') + '&cus_pwd=' + this.getCookie('cook_cus_pwd') + '&id=' + this.$route.params.id)
        },
        orderjump (sign) { // 跳转链接
            let links
            if (sign == 1) {
                links = '订货详情'
            } else if (sign == 2) {
                links = '出库/发货/物流'
            } else if (sign == 3) {
                links = '付款记录'
            }
            this.$router.push({
                name: links,
                id: this.$route.params.id
            })
        },
        uploadBefore () { // 上传文件之前
            const check = this.uploadList.length < 5;
            if (!check) {
                this.$Message.warning({
                    content: '最多上传5张'
                });
            }
            return check;
        },
        uploadProgress (event, file, fileList) { // 文件上传时
            console.log('上传时')
            console.log(event)
            console.log(file)
            console.log(fileList)
        },
        uploadSuccess (response, file, fileList) { // 文件上传成功
            console.log('上传成功')
            console.log(response)
            console.log(file)
            console.log(fileList)
            if (!response.error) {
                // file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
                // file.name = '7eb99afb9d5f317c912f08b5212fd69a';
                this.getInfo()
                this.$Message.success(file.name + '上传成功')
            } else {
                this.$Message.warning(response.msg)
            }
        },
        uploadError (error, file, fileList) { // 文件上传失败
            console.log('上传失败')
            console.log(error)
            console.log(file)
            console.log(fileList)
            this.$Message.error({
                content: fileList.name + '上传失败'
            })
        },
        uploadRemove (file, fileList) { // 文件列表移除文件时
            console.log('移除')
            console.log(file)
            console.log(fileList)
        },
        uploadExceededSize (file, fileList) { // 文件超出大小
            console.log('超出大小')
            console.log(file)
            console.log(fileList)
        },
        deluploadfile (file) { // 删除上传文件
            this.delupload(file)
            // const fileList = this.$refs.upload.fileList;
            // this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        },
        TimeDown (endDateStr) { // 倒计时
            //结束时间
            var endDate = new Date(endDateStr);
            //当前时间
            var nowDate = new Date();
            //相差的总秒数
            var totalSeconds = parseInt((endDate - nowDate) / 1000);
            //天数
            var days = Math.floor(totalSeconds / (60 * 60 * 24));
            //取模（余数）
            var modulo = totalSeconds % (60 * 60 * 24);
            //小时数
            var hours = Math.floor(modulo / (60 * 60));
            modulo = modulo % (60 * 60);
            //分钟
            var minutes = Math.floor(modulo / 60);
            //秒
            var seconds = modulo % 60;
            //输出到页面
            if (days > 0) {
                this.autocancletime = days + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒"
            } else if (hours > 0) {
                this.autocancletime = hours + "小时" + minutes + "分钟" + seconds + "秒"
            } else if (minutes > 0) {
                this.autocancletime = minutes + "分钟" + seconds + "秒"
            } else if (seconds > 0) {
                this.autocancletime = seconds + "秒"
            } else {
                this.autocancletime = '订单已过期'
            }
            //延迟一秒执行自己
            setTimeout(() => {
                this.TimeDown(endDateStr);
            }, 1000)
        },
        againbuyBtn () { // 再次购买
            this.orderpopup = true
            this.orderpopupsign = 0
            this.orderpopupmsg = '购物车中的原有商品会被清空！'
        },
        cancelorderBtn () { // 取消订单
            this.ordercanceljudge()
        },
        returnorderBtn () { // 申请退货
            this.$router.push({
                name: '申请退货',
                id: this.$route.params.id,
            })
        },
        orderpopupOk () { // 再次购买
            // 0 再次购买 1 删除已上传附件
            if (this.orderpopupsign == 0) {
                let newItem = [] // 添加到购物车的字段
                for (var i = 0; i < this.goodslist.length; i++) {
                    newItem.push({
                        gg_id: this.goodslist[i].goodsdetid, // 规格id
                        id: this.goodslist[i].id, // 商品id
                        num: this.goodslist[i].pcordernum, // 商品数量
                        unitshow: this.goodslist[i].unitshow, // 大小单位切换 false 小 true 大
                        remarks: '', // 备注信息
                    })
                }
                this.$store.dispatch('againShopCartListFun', newItem)
                this.$router.push('/ShoppingCart')
            }
        },
        cancelorderOk (e) { // 填写取消订单原因
            this.cancelorderShow = false
            this.cancelorderInfo = e
            this.ordercancel()
        },
        cancelorderCancel () { // 关闭备注弹窗
            this.cancelorderShow = false
        },
        payBtn () { // 支付按钮
            this.$router.push({
                name: '支付',
                params: {
                    type: 0,
                    id: this.$route.params.id
                }
            })
        }
    },
    watch: {
        sort (newVal, oldVal) {
            this.getInfo()
        }
    },
    filters: {
        moneyFilter (money) {
            return toMoney(money)
        }
    },
    created () {
        this.getInfo()
    },
    mounted () {
        // 获取上传列表
        this.uploadList = this.$refs.upload.fileList
    },
}
</script>

<style scoped>

.orderdetails_info_list > ul > li {
    display: flex;
    flex-direction: row;
    margin-top: 10px;
}

.orderdetails_info_left {
    width: 84px;
    flex-grow: 0;
    flex-shrink: 0;
}

.orderdetails_info_left > span {
    font-size: 16px;
    color: #666;
    display: block;
}

.orderdetails_info_left > span.letter::first-letter {
    margin-right: 2em;
}

.orderdetails_info_right {
    flex-grow: 1;
    flex-shrink: 1;
}

.orderdetails_info_right > span {
    font-size: 16px;
    color: #333;
    display: block;
}

.orderdetails_info_right > small {
    margin-top: 1px;
    margin-right: 20px;
    font-size: 16px;
    color: #666;
    display: inline-block;
}

.orderdetails_info_content {
    padding: 10px 30px 26px 30px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/order/orderdetails.vue